import React, { useState, useEffect } from "react";
import SideBar from "../../../../components/SideBar";
import Navbar from "../../../../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import PR_Table from "../../../../modules/HR/PRForm/Component/PR_Table";
import FormTable from "../../../../components/FormTable";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";

const CompanyMasterTable = () => {
  const navigate = useNavigate();
  const [CompanyMaster, setCompanyMaster] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const columns = {
    Code: { text: "Code" },
    Name: { text: "Name" },
    StartTime: { text: "Start Time", align:"center" },
    EndTime: { text: "End Time", align:"center" },
    IsClosed: { text: "Close", align:'center' },
  };
  const defaultColumns = {
    Code: true,
    Name: true,
    StartTime: true,
    EndTime: true,
    IsClosed: true,
  };

  const fetchMaster = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}branch`);
      if (response.status === 200) {
        const companyData = response.data.data;
        const updatedData = companyData.map(item => ({
            ...item,
            IsClosed: item.IsClosed === 0 ? 'No' : 'Yes'
          }));
          setCompanyMaster(updatedData);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Course:", error);
    }
  };

  useEffect(() => {
    fetchMaster();
  }, []);

  const handleEdit = (id) => {
    console.log("Check ID", id);
    navigate(`/editbranchmaster/${id.ID}`);
  };

  return (
    <>
      <div className="Nav">
        <Navbar />
      </div>
      <div className="nest-page">
        <SideBar />
        <div className="container-fluid" id="skill_section">
          <div className="row">
            <div className="container-fluid">
              <div className="col-lg-12 d-flex justify-content-between mt-2">
                <h3 className="heading skill-heading">
                  <i className="bi bi-bookmark-plus-fill"></i>Branch Master
                </h3>
                <div>
                  <Link to="/branchmaster" className="custom-btn">
                    <i className="fa fa-plus"></i> Add
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* table section */}
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
              {/* <FormTable 
                                 data={CompanyMaster}
                                 columns={columns}
                                 defaultColumns={defaultColumns}
                                 itemsPerPage={10}
                                 searchTerm={searchTerm}
                                 setSearchTerm={setSearchTerm}
                                 Path="/editbranchmaster"
                            /> */}
              <PR_Table
                data={CompanyMaster}
                columns={columns}
                defaultColumns={defaultColumns}
                itemsPerPage={10}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                showIcon2={false}
                showIcon3={false}
                showIcon4={false}
                showIcon5={false}
                handleIcon1={handleEdit}
                // handleIcon3={handleView}
                add
                more
                function
                icons={{
                  Icon1: <i class="bi bi-pencil-square icons"></i>,
                  Icon2: <i class="bi bi-trash-fill icons"></i>,
                  Icon3: <i class="bi bi-eye-fill icons"></i>,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyMasterTable;
